import { SHARED_EMAIL_DISABLED_ERROR_CODE } from '@/modules/workspace/public';
/** code → i18n translation key */
export const CONTACT_ERROR_CODE_MAP = {
    // Type
    'Contact.Type.Invalid': 'contact.create.validation.contactTypeRequired',
    // Categories / Source (defensive — FE guards payload shape, picker can't emit invalid/duplicate)
    'Contact.Categories.InvalidValue': 'contact.create.errors.serverError',
    'Contact.Categories.Duplicate': 'contact.create.errors.serverError',
    'Contact.Source.Invalid': 'contact.create.errors.serverError',
    // Preferred channel (defensive — the value comes from a bounded picker, so an out-of-enum
    // value can only come from a payload the UI cannot produce; same shape as Source above)
    'Contact.PreferredChannel.Invalid': 'contact.create.errors.serverError',
    // Creation operation id (defensive — the S8 saga tag is minted by the FE and never typed;
    // Guid.Empty reaching the BE is a client bug, not something the user can correct)
    'Contact.CreationOperationId.Invalid': 'contact.create.errors.serverError',
    // Birth date (defensive — the creation modal has no birth-date field; the code is
    // shared with the update flow where the Details tab maps it to a field error)
    'Contact.BirthDate.InFuture': 'contact.create.errors.serverError',
    // Middle name / Birth place / Nationality / Spoken language (defensive: the creation modal has
    // no fields for these, they ship with the OP-6948 Detail-tab Identity block)
    'Contact.MiddleName.TooLong': 'contact.create.errors.serverError',
    'Contact.BirthPlace.TooLong': 'contact.create.errors.serverError',
    'Contact.Nationality.Invalid': 'contact.create.errors.serverError',
    'Contact.SpokenLanguage.Invalid': 'contact.create.errors.serverError',
    // Email / Phone
    'Contact.MainEmail.Invalid': 'contact.create.validation.emailInvalid',
    'Contact.MainPhone.Invalid': 'contact.create.validation.phoneInvalid',
    // OP-8215: sharing refused because the workspace switched it off after the modal opened.
    [SHARED_EMAIL_DISABLED_ERROR_CODE]: 'contact.detail.addEmail.errors.sharedEmailsDisabled',
    // Duplicate the dedup panel did not catch (its lookup failed or raced the submit).
    'CommunicationChannel.Email.AlreadyExists': 'contact.detail.editEmail.errors.emailAlreadyExists',
    // Organisation + Position (pairing rules — OP-5474)
    'Contact.OrganisationId.RequiredWhenPositionProvided': 'contact.create.validation.organisationRequired',
    'Contact.OrganisationId.NotAllowedForIndividual': 'contact.create.errors.serverError',
    'Contact.Position.RequiredWhenOrganisationProvided': 'contact.create.validation.positionRequired',
    'Contact.Position.NotAllowedForIndividual': 'contact.create.errors.serverError',
    'Contact.Position.TooLong': 'contact.create.validation.positionTooLong',
};
/** code → field ref key (null = show as server error banner) */
export const CONTACT_ERROR_FIELD_MAP = {
    'Contact.Type.Invalid': 'contactTypeError',
    'Contact.Categories.InvalidValue': null,
    'Contact.Categories.Duplicate': null,
    'Contact.Source.Invalid': null,
    'Contact.PreferredChannel.Invalid': null,
    'Contact.CreationOperationId.Invalid': null,
    'Contact.BirthDate.InFuture': null,
    'Contact.MiddleName.TooLong': null,
    'Contact.BirthPlace.TooLong': null,
    'Contact.Nationality.Invalid': null,
    'Contact.SpokenLanguage.Invalid': null,
    'Contact.MainEmail.Invalid': 'mainEmailError',
    'Contact.MainPhone.Invalid': 'phoneError',
    [SHARED_EMAIL_DISABLED_ERROR_CODE]: null,
    'CommunicationChannel.Email.AlreadyExists': 'mainEmailError',
    'Contact.OrganisationId.RequiredWhenPositionProvided': 'organisationIdError',
    'Contact.OrganisationId.NotAllowedForIndividual': null,
    'Contact.Position.RequiredWhenOrganisationProvided': 'positionError',
    'Contact.Position.NotAllowedForIndividual': null,
    'Contact.Position.TooLong': 'positionError',
};
/**
 * Maps a BE error code to its i18n key and target field ref.
 * Returns null when the code is unknown (triggers the generic server error path).
 */
export function mapErrorCodeToField(code) {
    const i18nKey = CONTACT_ERROR_CODE_MAP[code];
    if (!i18nKey)
        return null;
    return { i18nKey, field: CONTACT_ERROR_FIELD_MAP[code] ?? null };
}
